
import { Col, Container, Row } from "react-bootstrap";
import "./footer.css";
import "../../theme/index.css";
import fullLogo from "../../assets/CASPER KARMA YOGA FEST_LOGO.webp";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebookSquare, faInstagram } from "@fortawesome/free-brands-svg-icons";

export const Footer = () => {
  return (
    <div className="bluegray-bkg">
      <Container>
        <Row className="footer-row">
          <Col className="center">
            <img src={fullLogo} alt="Casper Karma Yoga Festival Logo" />
            <Row className="justify-content-md-center">
              <Col xs={7} md={6}>
                <div className="location">
                  <div className="left location-title">2025 Event Location</div>
                  <a href="https://maps.app.goo.gl/QhUbZKyHFwPpSDrd8" className="left venue" target="_blank" rel="noreferrer"><div className="location-details">
                    Washington Park
                  </div>
                  </a>
                  <div className="left location-details">
                      951 S Jefferson St
                  </div>
                  <div className="left location-details">Casper, WY 82601</div>
                </div>
              </Col>
              <Col className="justify-content-md-center">
                <div className="vert-line"></div>
              </Col>
              <Col xs={3} md={5} id="footer" >
                <div className="social">
                  <div className="left">
                    <a className="social-links" target="_blank" rel="noreferrer" href="https://www.facebook.com/casperkarmayogafest" ><FontAwesomeIcon className="left social-icon" icon={faFacebookSquare} /></a>
                    <a className="social-links" target="_blank" rel="noreferrer" href="https://www.instagram.com/casperkarmayogafest/"><FontAwesomeIcon className="left social-icon " icon={faInstagram} /></a>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
